import { GoogleOAuthProvider } from '@react-oauth/google';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import './components/Menu/TopMenu/styles/styles.css';
import './components/Dashboards/Admin/styles/styles.css';
import './components/Dashboards/Users/styles/Users.css';
import App from './App';
import { AuthProvider } from './components/Providers/Auth';
import { GuestAuthProvider } from './components/Providers/GuestAuth';
import { MonitoringProvider } from './components/Providers/Monitoring';
import { NotificationProvider } from './components/Providers/Notification';
import { PushNotificationProvider } from './components/Providers/PushNotifications';
import { ReactQueryProvider } from './components/Providers/ReactQueryProvider';
import { setupApiErrorInterceptor } from './modules/apiErrorLogger';
import { config } from './modules/config';
import { setupTransactionInterceptor } from './modules/transaction';
import reportWebVitals from './reportWebVitals';

setupTransactionInterceptor();
setupApiErrorInterceptor();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ReactQueryProvider>
        <ReactQueryDevtools initialIsOpen={false} />
        <MonitoringProvider>
          <NotificationProvider>
            <PushNotificationProvider>
              <AuthProvider>
                <GuestAuthProvider>
                  <GoogleOAuthProvider clientId={config.google.clientId}>
                    <App />
                  </GoogleOAuthProvider>
                </GuestAuthProvider>
              </AuthProvider>
            </PushNotificationProvider>
          </NotificationProvider>
        </MonitoringProvider>
      </ReactQueryProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
